import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#252525",
    "col2d": "#9A9956",
    "col2n": "#C4C389"
}
function FacMou103({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col2n}
                    d="M36.95 0H0l4.35 16.7H29.7L36.95 0z"
                    id="FacMou103__Symbol_188_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M30.25 13.55q-.4.3-.7.5-2.4 1.55-3.75-.7H25q-3.6 3.25-7.15 0h-.75q-3.55 3.25-7.15 0h-.8q-1.3 2.15-3.5.85-.55-.35-1.15-.85l-1.25-.9 1.1 4.25H29.7l1.8-4.2-1.05.9v-.05l-.2.2M31.2 2.1l.2.1q.55.3 1.1.75l2.45 1.7 2-4.65H0l1 3.9 1.45-1v.05q.3-.25.55-.4.15-.1.25-.15 3-1.9 5.9.55h.8q1-.8 1.95-1.2 1.75-.7 3.4 0 .9.4 1.8 1.2h.75q.9-.8 1.8-1.2 1.65-.7 3.4 0 .95.4 1.95 1.2h.8Q28.45.7 31.2 2.1z"
                    id="FacMou103__Symbol_189_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1n}
                    d="M41.75 20.95q2.75-5.8 3.2-11.9Q45 7.5 44.8 6.2q-.15-.8-.35-1.5-.75-2.35-2.55-3.35-.5-.25-1.1-.45-2.85-1-7.55-.85H30.3Q19.6 0 10.1.05 7.6.1 5.7.5q-.85.15-1.55.4-.6.2-1.1.45Q-.15 3.1 0 9.05q.45 6.1 3.2 11.9.25.6.6 1.2l.1.2q.4.8.9 1.65 2.4 3.6 7.35 4.2H32.8q4.95-.6 7.35-4.2.5-.85.9-1.65l.1-.2q.35-.6.6-1.2m-3.7-12.2v.1q.05.05.05.15.3 2.05-.05 4.1-.05.3-.1.65l-.2.8q-.1.4-.2.85-.15.5-.3 1.05-.25.6-.55 1.2-.25.55-.55 1.15-.1.25-.25.55-.25.45-.6.95-1.1 1.35-3.05 1.85-9.8.7-19.6 0-2-.5-3.1-1.85-.3-.5-.55-.95-.15-.3-.25-.55-.35-.6-.6-1.15-.5-1.1-.8-2.25v-.1q-.1-.4-.2-.75l-.2-.8H6.9q-.05-.35-.1-.65V13q-.3-2-.05-4 0-.1.05-.15v-.1q0-.1.05-.2.05-.25.1-.45.5-1.55 2.1-1.95 13.5-.7 26.75 0 1.65.4 2.1 1.95.05.2.1.45.05.1.05.2z"
                    id="FacMou103__Symbol_187_0_Layer0_0_FILL"
                />
                <path
                    d="M206.95 215.95q-.95-.7-2.4-.75-6.05-.15-12.05-.15-6.025.001-12.05.15-1.473.046-2.4.75-.46.339-.8.75-.447.794-.65 1.85-.398 3.494.65 6.85.308 1.008.8 2.55.535 1.535 2 2.85 1.467 1.366 3.65 1.3 4.4.195 8.8.2 4.4 0 8.8-.2 2.2.05 3.65-1.25 1.45-1.35 1.95-2.9.55-1.55.85-2.55 1.05-3.35.65-6.8-.2-1.1-.65-1.85-.35-.45-.8-.8m.45 1.75q.05.2.1.45.05.1.05.2v.1q.05.05.05.15.25 1.95-.05 3.95l-.1.6h-6.65v-7.4h4.05q2 .25 2.55 1.95m-22.45-1.95h7.2v7.4H185l-.05-7.4m7.9 0h7.2l-.05 7.4h-7.15v-7.4m-15.35 2.4q.05-.25.1-.45.55-1.7 2.55-1.95h4.05v7.4h-6.65l-.1-.6q-.3-2-.05-3.95 0-.1.05-.15v-.1q0-.1.05-.2m23.3 13.3v-7.5h6.45q-1.15 7.6-6.45 7.5m-7.95.05v-7.55H200v7.55h-7.15m-.7-7.55v7.55H185v-7.55h7.15m-7.95 0v7.5q-5.325.084-6.45-7.5h6.45z"
                    id="FacMou103__Layer1_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacMou103__Symbol_188_0_Layer0_0_FILL"
                transform="translate(175.05 215.2)"
                id="FacMou103__col2n"
            />
            <use
                xlinkHref="#FacMou103__Symbol_189_0_Layer0_0_FILL"
                transform="translate(175.05 215.2)"
                id="FacMou103__col2d"
            />
            <use
                xlinkHref="#FacMou103__Symbol_187_0_Layer0_0_FILL"
                transform="translate(170.05 209.55)"
                id="FacMou103__col1n"
            />
            <use xlinkHref="#FacMou103__Layer1_0_FILL" />
        </g></g>
    )
}
export default FacMou103
